/*
	shorthash
	(c) 2013 Bibig
	
	https://github.com/bibig/node-shorthash
	shorthash may be freely distributed under the MIT license.
*/
function bitwise(str) {
  var hash = 0;
  if (str.length == 0) return hash;

  for (var i = 0; i < str.length; i++) {
    var ch = str.charCodeAt(i);
    hash = (hash << 5) - hash + ch;
    hash = hash & hash; // Convert to 32bit integer
  }

  return hash;
}

function binaryTransfer(integer, binary) {
  binary = binary || 62;
  var stack = [];
  var num;
  var result = '';
  var sign = integer < 0 ? '-' : '';

  function table(num) {
    var t = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    return t[num];
  }

  integer = Math.abs(integer);

  while (integer >= binary) {
    num = integer % binary;
    integer = Math.floor(integer / binary);
    stack.push(table(num));
  }

  if (integer > 0) {
    stack.push(table(integer));
  }

  for (var i = stack.length - 1; i >= 0; i--) {
    result += stack[i];
  }

  return sign + result;
}

function unique(text) {
  var id = binaryTransfer(bitwise(text), 61);
  return id.replace('-', 'Z');
}

exports.bitwise = bitwise;
exports.binaryTransfer = binaryTransfer;
exports.unique = unique;